import { useCallback } from "react";

import { useTwoFactorAction } from "@/shared/hooks/useTwoFactorAction";

import { PaymentIncidentsService } from "../services/paymentIncidents.service";
import type { PaymentIncidentReport } from "../types/paymentIncidents.types";

/**
 * Copying the report for the provider, behind the TOTP. The backend reads the provider before answering (up
 * to ~10 s), so the challenge closes as soon as the code leaves and the caller shows its own progress.
 * Resolves null when the person cancels the challenge.
 */
export function useIncidentReport() {
  const twoFactor = useTwoFactorAction<PaymentIncidentReport>({ closeOnSend: true });
  const { start } = twoFactor;
  const copyReport = useCallback(
    (incidentId: string) => start((code) => PaymentIncidentsService.report(incidentId, code)),
    [start],
  );
  return { copyReport, twoFactor };
}
